module.exports = __webpack_public_path__ + "media/img/corporate/premium-0d2337882cf3d2b5d3cfc25816a13a7c.svg";